<div *ngIf="!mobile" class="unleash-section-container-desktop">
    <div class="unleash-section-content">
        <div class="text-container">
            <span class="bold title" [innerHTML]="'unleash-section.title-1' | translate" translate></span>
            <span class="max-bold title" [innerHTML]="'unleash-section.title-2' | translate" translate></span>
        </div>

        <app-button *ngIf="!isLogged" [big]="true" [whiteOnDarkestGray]="true" [label]="'common.join-now' | translate" [targetInternal]="'/register'"></app-button>
        <app-button *ngIf="isLogged" [big]="true" [whiteOnDarkestGray]="true" [label]="'common.go-to-console' | translate" (onClick)="goToConsole()"></app-button>

        <img class="background" src="/assets/img/backgrounds/big-orange-eclipse.svg" alt="unleash background 1" />
    </div>
</div>

<div *ngIf="!!mobile" class="unleash-section-container-mobile">
    <div class="unleash-section-content-mobile">
        <div class="text-container">
            <span class="bold title center" [innerHTML]="'unleash-section.title-1' | translate" translate></span>
            <span class="max-bold title center" [innerHTML]="'unleash-section.title-2' | translate" translate></span>
        </div>

        <app-button *ngIf="!isLogged" [big]="true" [whiteOnDarkestGray]="true" [label]="'common.join-now' | translate" [targetInternal]="'/register'"></app-button>
        <app-button *ngIf="isLogged" [big]="true" [whiteOnDarkestGray]="true" [label]="'common.go-to-console' | translate" (onClick)="goToConsole()"></app-button>

        <img class="background" src="/assets/img/backgrounds/big-orange-eclipse-mobile.svg" alt="unleash background 1" />
    </div>
</div>
